import { render, staticRenderFns } from "./DragDrop.vue?vue&type=template&id=a5655354"
import script from "./DragDrop.vue?vue&type=script&lang=ts"
export * from "./DragDrop.vue?vue&type=script&lang=ts"
import style0 from "./DragDrop.vue?vue&type=style&index=0&id=a5655354&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports